export default {
  0x00: { name: 'ACK' },
  0x01: { name: 'WAIT' },
  0x02: { name: 'INSERT SYSTEM DISK' },
  0x03: { name: 'INVALID PARAMETER NUMBER' },
  0x04: { name: 'INVALID PARAMETER VALUE' },
  0x05: { name: 'INVALID INSTRUMENT' },
  0x06: { name: 'INVALID LAYER' },
  0x07: { name: 'LAYER IN USE' },
  0x08: { name: 'INVALID WAVESAMPLE' },
  0x09: { name: 'WAVESAMPLE IN USE' },
  0x0a: { name: 'INVALID WAVESAMPLE DATA RANGE' },
  0x0b: { name: 'FILE NOT FOUND' },
  0x0c: { name: 'MEMORY FULL' },
  0x0d: { name: 'INSTRUMENT IN USE' },
  0x0e: { name: 'NO MORE LAYERS' },
  0x0f: { name: 'NO MORE WAVESAMPLES' },
  0x11: { name: 'WAVESAMPLE IS A COPY' },
  0x12: { name: 'ZONE TOO BIG' },
  0x13: { name: 'SEQUENCER MUST BE STOPPED' },
  0x14: { name: 'DISK ACCESS IN PROGRESS' },
  0x15: { name: 'DISK FULL' },
  0x16: { name: 'LOOP IS TOO LONG' },
  0x17: { name: 'NAK' },
  0x18: { name: 'NO LAYER EDIT' },
  0x19: { name: 'NO MORE PITCH TABLES' },
  0x1a: { name: 'CROSS FADE LENGTH IS ZERO' },
  0x1b: { name: 'CROSS FADE LENGTH IS GREATER THAN 50%' },
  0x1c: { name: 'LOOP START TOO CLOSE TO SAMPLE START' },
  0x1d: { name: 'LOOP END TOO CLOSE TO SAMPLE END' },
  0x1e: { name: 'QUIET LAYER' },
};
